var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPilotsGlow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 655.951,
    height: 1062.28,
    viewBox: "0 0 655.951 1062.28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3",
    opacity: 0.3,
    d: "M327.976 0.5C418.306 0.5 500.163 59.7959 559.464 155.83C618.759 251.856 655.451 384.547 655.451 531.139C655.451 677.731 618.76 810.422 559.464 906.448C500.163 1002.48 418.306 1061.78 327.976 1061.78C237.645 1061.78 155.788 1002.48 96.4873 906.448C37.1916 810.422 0.5 677.731 0.5 531.139C0.500061 384.547 37.1917 251.856 96.4873 155.83C155.788 59.7959 237.645 0.5 327.976 0.5Z",
    fill: "url(#paint0_linear_0_4)",
    stroke: "url(#paint1_linear_0_4)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_4",
    x1: 0,
    y1: 531.139,
    x2: 655.951,
    y2: 531.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.5,
    style: {
      stopColor: "#D9D9D9",
      stopColor: "color(display-p3 0.8510 0.8510 0.8510)",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373",
    stopOpacity: 0,
    style: {
      stopColor: "none",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_4",
    x1: 327.976,
    y1: 0,
    x2: 327.976,
    y2: 1062.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    style: {
      stopColor: "#D9D9D9",
      stopColor: "color(display-p3 0.8510 0.8510 0.8510)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161616",
    style: {
      stopColor: "#161616",
      stopColor: "color(display-p3 0.0863 0.0863 0.0863)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPilotsGlow);
export default __webpack_public_path__ + "static/media/pilots-glow.5c89b50065e7333ee3199c8f7eaef3a1.svg";
export { ForwardRef as ReactComponent };